import { channelMedia, channels } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import { showToast } from "@/hooks/useToast";

export default function ChannelGuide() {
  return (
    <section id="channels" className="scroll-mt-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <Reveal className="max-w-2xl">
          <p className="text-xs tracking-widest text-primary-600">DEEP CHANNELS</p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
            深层渠道入口导览
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            入口按「少走一步」的原则摆放：收藏之后直接进入，不必再经过列表。下面四组是本期内参开放的通道。
          </p>
        </Reveal>

        <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2 md:gap-4">
          {channelMedia.map((media, index) => (
            <Reveal key={media.caption} delay={index * 90}>
              <figure className="group relative h-56 overflow-hidden rounded-lg border border-background-300/70 md:h-72">
                <img
                  src={media.image}
                  alt={`88看料 ${media.caption}`}
                  title={`88看料 深层渠道 隐藏内容 ${media.caption}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/25 to-transparent" />
                <figcaption className="absolute inset-x-0 bottom-0 flex items-center justify-between p-4 md:p-5">
                  <span className="font-heading text-sm font-semibold text-background-50 md:text-base">
                    {media.caption}
                  </span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-md bg-background-50/90 text-foreground-950">
                    <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <div className="mt-3 md:mt-4">
          {channels.map((channel, index) => (
            <Reveal key={channel.no} delay={index * 60}>
              <div className="group grid grid-cols-1 items-center gap-3 border-b border-background-300/60 py-5 md:grid-cols-[72px_1fr_auto] md:gap-6">
                <span className="font-heading text-2xl font-bold tabular-nums text-background-400 transition-colors group-hover:text-primary-500 md:text-3xl">
                  {channel.no}
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                    {channel.name}
                  </h3>
                  <p className="mt-1 max-w-2xl text-[13px] leading-relaxed text-foreground-600">
                    {channel.desc}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="rounded-full border border-secondary-200 bg-secondary-50 px-2.5 py-1 text-xs text-secondary-900 whitespace-nowrap">
                    {channel.status}
                  </span>
                  <button
                    type="button"
                    onClick={() => showToast(`已进入「${channel.name}」（演示通道）`)}
                    className="flex items-center gap-1 rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 whitespace-nowrap"
                  >
                    直达
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-arrow-right-line" aria-hidden="true" />
                    </span>
                  </button>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}